import { render, staticRenderFns } from "./CourseInfoCreate.vue?vue&type=template&id=1268b772&"
import script from "./CourseInfoCreate.vue?vue&type=script&lang=ts&"
export * from "./CourseInfoCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports